import Toast from './toast.vue'
export default {
  install (Vue) {
    Vue.component('CompToast', Toast)
    Vue.prototype.$toastShow = null
    Vue.prototype.$toast = function (tips, options = {}) {
      if (!Vue.prototype.$toastShow) {
        const toastTpl = Vue.extend({
          name: 'Comptoast',
          data () {
            return {
              show: false,
              type: options.type || false
            }
          },
          render (h) {
            const props = {
              text: tips,
              show: this.show
            }
            return h('comp-toast', { props })
          }
        })
        /* eslint-disable-next-line */
        const toastVM = new toastTpl()
        let vm = toastVM.$mount()
        const el = vm.$el
        vm.show = true
        Vue.prototype.$toastShow = true
        document.body.appendChild(el) // 把生成的提示的dom插入body中
        const t2 = setTimeout(() => {
          clearTimeout(t2)
          vm.show = false
          document.body.removeChild(el)
          toastVM.$destroy()
          vm = null
          Vue.prototype.$toastShow = null
          options.callback &&
            typeof options.callback === 'function' &&
            options.callback()
        }, options.duration || 2000)
      }
    }
  }
}
